import { c as _c } from "react/compiler-runtime";
import { KeyboardEventHandler, useEffect, useState } from 'react';
import { Key } from 'record-it-utils/utils/Key/Key';
import { useEventCallback } from '../../hooks/useEventCallback';
export function useHighlightedSelectOption(t0) {
  const $ = _c(26);
  const {
    options,
    currentOption,
    active,
    onOptionSelected
  } = t0;
  const [highlightedOption, setHighlightedOption] = useState(null);
  let t1;
  let t2;
  if ($[0] !== active || $[1] !== currentOption) {
    t1 = () => {
      if (active) {
        setHighlightedOption(currentOption);
      }
    };
    t2 = [currentOption, active, setHighlightedOption];
    $[0] = active;
    $[1] = currentOption;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== options) {
    t3 = index => {
      setHighlightedOption(options[index] ?? null);
    };
    $[4] = options;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const highlightAtIndex = t3;
  let t4;
  if ($[6] !== highlightedOption || $[7] !== options) {
    t4 = () => highlightedOption ? options.indexOf(highlightedOption) : -1;
    $[6] = highlightedOption;
    $[7] = options;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const getCurrentIndex = t4;
  let t5;
  if ($[9] !== getCurrentIndex || $[10] !== highlightAtIndex || $[11] !== options.length) {
    t5 = () => {
      const previousIndex = getCurrentIndex() - 1;
      if (previousIndex >= 0) {
        highlightAtIndex(previousIndex);
      } else {
        highlightAtIndex(options.length - 1);
      }
    };
    $[9] = getCurrentIndex;
    $[10] = highlightAtIndex;
    $[11] = options.length;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const highlightPreviousOption = t5;
  let t6;
  if ($[13] !== getCurrentIndex || $[14] !== highlightAtIndex || $[15] !== options.length) {
    t6 = () => {
      const nextIndex = getCurrentIndex() + 1;
      if (nextIndex < options.length) {
        highlightAtIndex(nextIndex);
      } else {
        highlightAtIndex(0);
      }
    };
    $[13] = getCurrentIndex;
    $[14] = highlightAtIndex;
    $[15] = options.length;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const highlightNextOption = t6;
  let t7;
  if ($[17] !== active || $[18] !== highlightNextOption || $[19] !== highlightPreviousOption || $[20] !== highlightedOption || $[21] !== onOptionSelected) {
    t7 = event => {
      if (!active) {
        return;
      }
      bb27: switch (event.key) {
        case Key.ArrowUp:
          {
            highlightPreviousOption();
            event.preventDefault();
            break bb27;
          }
        case Key.ArrowDown:
          {
            highlightNextOption();
            event.preventDefault();
            break bb27;
          }
        case Key.Enter:
          {
            if (highlightedOption) {
              onOptionSelected(highlightedOption);
            }
            break bb27;
          }
        default:
      }
    };
    $[17] = active;
    $[18] = highlightNextOption;
    $[19] = highlightPreviousOption;
    $[20] = highlightedOption;
    $[21] = onOptionSelected;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const handleInputKeydown = useEventCallback(t7);
  let t8;
  if ($[23] !== handleInputKeydown || $[24] !== highlightedOption) {
    t8 = {
      highlightedOption,
      handleInputKeydown
    };
    $[23] = handleInputKeydown;
    $[24] = highlightedOption;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}
export type UseHighlightedSelectOptionOptions<T> = {
  options: Array<T>;
  currentOption: T;
  active: boolean;
  onOptionSelected: (option: T) => void;
};
export type UseHighlightedSelectReturnValue<T> = {
  highlightedOption: T | null;
  handleInputKeydown: KeyboardEventHandler;
};